import { render } from "./TableOrder.vue?vue&type=template&id=55a2909a"
import script from "./TableOrder.vue?vue&type=script&lang=js"
export * from "./TableOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__